import modulo_empleados from "./modulos/modulo_empleados";
import modulo_estado from "./modulos/modulo_estado";
import modulo_provincias from "./modulos/modulo_provincias";
import modulo_roles from "./modulos/modulo_roles";
import modulo_clientes from "./modulos/modulo_clientes";
import modulo_pedidos from "./modulos/modulo_pedidos";
import modulo_indexed_db from "./modulos/modulo_indexed_db";
import modulo_filtros from "./modulos/modulo_filtros";
import modulo_facturas from "./modulos/modulo_facturas";
import Vue from "vue";
import Vuex from "vuex";
import modulo_productos from "./modulos/modulo_productos";
import modulo_proveedores from "./modulos/modulo_proveedores";
import modulo_ordenes from "./modulos/modulo_ordenes";
import modulo_albaranes from "./modulos/modulo_albaranes";
import modulo_albaran_venta from "./modulos/modulo_albaran_venta";
import modulo_productos_compra from "./modulos/modulo_productos_compra";
import modulo_presupuestos from "./modulos/modulo_presupuesto";
import modulo_metodos_pago from "./modulos/modulo_metodos_pago";
import modulo_users from "./modulos/modulo_users";

Vue.use(Vuex);

const store = new Vuex.Store({
    strict: false,
    modules: {
        empleados: modulo_empleados,
        estado: modulo_estado,
        provincias: modulo_provincias,
        roles: modulo_roles,
        clientes: modulo_clientes,
        pedidos: modulo_pedidos,
        productos: modulo_productos,
        indexed_db: modulo_indexed_db,
        filtros: modulo_filtros,
        facturas: modulo_facturas,
        proveedores: modulo_proveedores,
        ordenes: modulo_ordenes, 
        albaranes: modulo_albaranes, 
        albaran_venta: modulo_albaran_venta, 
        productos_compra: modulo_productos_compra,
        presupuestos: modulo_presupuestos,
        metodos:modulo_metodos_pago,
        users: modulo_users,
    },
});

export default store;
